

import React from 'react';

const CustomDataTable = ({ data, fields }) => {
  if (!data || !data.length) {
    return null;
  }

  // derive columns from first row's keys
  const columns = fields.filter(f => f.checked);


  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          {columns.map(col => (
            <th
              key={col.label}
              style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(row => (
          <tr key={row._id}>
            {columns.map(col => (
              <td
                key={col.value}
                style={{ border: '1px solid #eee', padding: '8px' }}
              >
                {row[col.value]?.toString() ?? ''}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CustomDataTable;